/*
 * Fixed position footer
 * ----------------------------------------------- */
jQuery(window).on("load", function () {
  var $tab = $(".section-search-specialist .specialist-area li a");
  $tab.on("click", function () {
    $tab.removeClass("active");
    $(this).addClass("active");
  });
});
